import { Global } from "@emotion/react";
import type { SerializedStyles } from "@emotion/react";

import * as base from "@aviary/styles/aviaryNormalize.styles";

interface Props {
  /*
   * Allows you to pass in your own custom global styles
   */
  customStyles?: SerializedStyles;
  /*
   * Disables normalization (ONLY FOR USE WITHIN ADMIN)
   * SERIOUSLY, THIS PAINS ME TO ADD
   * Only pigeons can use this
   */
  noNormalization?: boolean;
}

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const AviaryGlobalStyles = ({ customStyles, noNormalization, ...rest }: Props) => {
  const globalStyles = [base.normalize, base.aviaryBaseStyles, customStyles];

  if (noNormalization) return null;

  return <Global styles={globalStyles} {...rest} />;
};

export { AviaryGlobalStyles };
